module.exports = __webpack_public_path__ + "static/media/website-16.69feb911.png";